<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('files')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ drive_uuid: $route.query.u }"
      :page_length="50"
      resource_url="/drive/file/datatables"
      mode="grid"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div class="controls">
              <div
                class="is-pulled-right has-text-danger"
                :data-tooltip="$t('delete')"
                @click="remove(item)"
              >
                <span class="icon"><i class="fa fa-trash"></i></span>
              </div>
              <div
                class="is-pulled-right has-text-warning"
                :data-tooltip="$t('details')"
                @click="details(item)"
              >
                <span class="icon"><i class="fa fa-info"></i></span>
              </div>
            </div>

            <!-- <div
              class="is-pulled-right has-text-info"
              :data-tooltip="$t('download')"
              @click="download(item)"
            >
              <span class="icon"><i class="fa fa-download"></i></span>
            </div> -->

            <figure
              class="image is-64x64 m-auto"
              @click="download(item)"
              :data-tooltip="$t('download')"
            >
              <img :src="calculate_icon(item)" />
            </figure>
          </div>
          <div class="card-content px-1 my-3">
            <div class="media">
              <div class="media-content">
                <p class="title is-7">
                  {{ item.name }}
                </p>
                <p class="subtitle is-7">
                  <!-- {{ item.settings.mimetype }} | -->
                  {{ translate_file_size(item.settings.size) }}
                  <!-- {{ item }} -->
                </p>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button is-small p-2"
              :data-tooltip="$t('details')"
              @click="details(item)"
            >
              <span class="icon"><i class="fa fa-eye"></i></span>
            </a>
            <a
              class="card-footer-item button is-small p-2"
              :data-tooltip="$t('download')"
              @click="download(item)"
            >
              <span class="icon"><i class="fa fa-download"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button is-small p-2"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
    <file-modal ref="file_modal" @success="refresh" />
    <detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  success_message,
  format_date_time,
  download,
  translate_file_size,
} from "@/utils";
import FileModal from "./file_modal/Index.vue";
import DetailModal from "./detail_modal/Index.vue";

export default {
  name: "FilesDatatable",
  components: { GenericTable, FileModal, DetailModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return format_date_time(row.create_date) || "";
            return `<div class="subtitle is-6">${format_date_time(
              row.create_date
            )}</div>
                    <div class="title is-6">${row.name}</div>
                    <div class="subtitle is-6">${
                      row.settings.mimetype
                    } | ${translate_file_size(row.settings.size)}</div>`;
          },
        },
        // {
        //   title: v.$t("name"),
        //   name: "name",
        //   searchable: true,
        //   width: "40%",
        //   data: (row) => {
        //     return row.name;
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.detail_modal.show_modal(uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("download"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  download(`/drive/file/download?uuid=${uuid}`, row.name)
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete file?"),
                    v,
                    () => {
                      del("/drive/file", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    translate_file_size,
    create() {
      let v = this;
      v.$refs.file_modal.show_modal();
    },
    mounted() {},
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    calculate_icon(file) {
      let v = this;
      if (file.settings.mimetype == "application/pdf")
        // return "https://static.vecteezy.com/system/resources/previews/015/081/201/non_2x/pdf-file-format-3d-rendering-isometric-icon-png.png";
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-pdf-color-red-icon.png";
      else if (file.settings.mimetype == "image/jpeg")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-jpeg-color-red-icon.png";
      else if (file.settings.mimetype == "image/png")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-png-color-red-icon.png";
      else if (file.settings.mimetype == "application/json")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-json-color-red-icon.png";
      else if (file.settings.mimetype == "application/x-javascript")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-js-color-red-icon.png";
      else if (
        file.settings.mimetype ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-xlsx-color-green-icon.png";
      else if (file.settings.mimetype == "text/x-python")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-py-color-green-icon.png";
      else if (file.settings.mimetype == "image/webp")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-webp-color-green-icon.png";
      else
        return "https://cdn.icon-icons.com/icons2/2753/PNG/512/ext_file_generic_filetype_icon_176256.png";
    },
    details(file) {
      let v = this;
      v.$refs.detail_modal.show_modal(file.uuid);
    },
    remove(file) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete file?"), v, () => {
        v.$root.loader(true);
        del("/drive/file", { uuid: file.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      });
    },
    download(file) {
      let v = this;
      download(`/drive/file/download?uuid=${file.uuid}`, file.name)
        .then(() => {
          success_message(v.$t("download complete"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.grid .cell .card figure:hover {
  transition: linear 0.1s;
  transform: scale(1.2, 1.2);
}

/* .grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
} */
</style>
